import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import DataGrid from '../../../../OurModules/DataGrid/src/index.js';
import moment from 'moment-timezone';
import * as FileSaver from 'file-saver';

/**
 * Container component for the Invoices and payments page.
 * 
 */

class InvoicesAndPayments extends React.Component {
    constructor(props) {
        super(props)
        this.goToInvoicesDetails = this.goToInvoicesDetails.bind(this);
        this.goToPaymentOptionsPage = this.goToPaymentOptionsPage.bind(this);
        this.goToInvoicesDetailsForLatestInvoice = this.goToInvoicesDetailsForLatestInvoice.bind(this);
        this.queueInvoiceDownload = this.queueInvoiceDownload.bind(this);
        this.dateChanged = this.dateChanged.bind(this);
        this.setStatus = this.setStatus.bind(this);
        this.setMemberName = this.setMemberName.bind(this);
        this.getCamelCasing = this.getCamelCasing.bind(this);
        this.addMonthField = this.addMonthField.bind(this);
        this.state = {
            showLoader: true,
            invoicesList: [],
            shouldLoadData: true,
            dateRange: localStorage.getItem('invoicesAndPaymentsDateRange')
                ? JSON.parse(localStorage.getItem('invoicesAndPaymentsDateRange'))
                : { from: moment().subtract(1, "months").format("MM/DD/YYYY"), to: moment().format("MM/DD/YYYY") },
            swhpShowLatestInvoiceSection: false,
            swhpLatestInvoice: {},
            isCobraMember: false
        };
    }

    componentDidMount() {
        logUI("MBHWeb.UI.InvoicesAndPayments.ComponentDidMount", new Date(), Tools.getURLPath());
        this.componentDidUpdate(this.props);
    }

    componentDidUpdate(prevProps) {
        const { hpIdentity, isFetching, swhp } = this.props;

        if (this.props.invoicesList !== prevProps.invoicesList || this.props.subscription !== prevProps.subscription) {
            if (this.props.invoicesList && this.props.subscription) {
                let invoices = this.props.invoicesList;
                let subscription = this.props.subscription;
                invoices = this.getCamelCasing(invoices);
                subscription = this.getCamelCasing(subscription);
                subscription.members = this.getCamelCasing(subscription.members);
                invoices = this.setStatus(invoices);
                invoices = this.setMemberName(invoices);
                invoices = this.addMonthField(invoices);
                this.setState({
                    invoicesList: invoices && invoices.length > 0 ? invoices : [],
                    showLoader: false,
                    swhpShowLatestInvoiceSection: invoices && invoices.length > 0 ? true : false, //for SWHP Commercial users
                    swhpLatestInvoice: invoices && invoices.length > 0 ? invoices.sort((a, b) => b.premiumDueDate - a.premiumDueDate)[0] : {} //for SWHP Commercial users
                })
            }
        }

        if ((this.props.invoicePDF !== prevProps.invoicePDF || this.props.error !== prevProps.error)) {
            this.handleInvoiceDownload();
        }

        if ((swhp || hpIdentity) && this.state.shouldLoadData && !isFetching) {
            this.getInvoices();
            this.props.getSubscriberInfo();
            this.state.shouldLoadData = false;
            if (hpIdentity) {
                this.setState({ isCobraMember: hpIdentity.roles.includes("CobraMembers") ? true : false });
            }
        }

    }

    getCamelCasing(object) {
        var newO, origKey, newKey, value;
        newO = {}
        if (object instanceof Array) {
            object = object.map((s) => {
                var newO, origKey, newKey, value;
                newO = {};

                for (origKey in s) {
                    if (s.hasOwnProperty(origKey)) {
                        newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
                        value = s[origKey];
                        newO[newKey] = value;
                    }
                }
                s = newO;
                return s;
            });
        }
        else {
            for (origKey in object) {
                if (object.hasOwnProperty(origKey)) {
                    newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
                    value = object[origKey];
                    newO[newKey] = value;
                }
            }
            object = newO;
        }
        return object;
    }

    setMemberName(invoices) {
        if (!invoices || invoices.length === 0) {
            return invoices;
        }
        invoices.map((invoice) => {
            if (this.props.subscription.members) {
                let subIndex = this.props.subscription.members.map((mem) => mem.memberType).indexOf('Subscriber');
                subIndex = subIndex == -1 ? 0 : subIndex;
                invoice.memberName = this.props.subscription.members[subIndex].firstName + " " + this.props.subscription.members[subIndex].lastName;
                invoice.relation = this.props.subscription.members[subIndex].relation;
                return invoice;
            }
            else if (this.props.subscription.Members) {
                let subIndex = this.props.subscription.Members.map((mem) => mem.MemberType).indexOf('SUBSCRIBER');
                subIndex = subIndex == -1 ? 0 : subIndex;
                invoice.memberName = this.props.subscription.Members[subIndex].FirstName + " " + this.props.subscription.Members[subIndex].LastName;
                invoice.relation = this.props.subscription.Members[subIndex].Relation;
                return invoice;
            }
        });
        return invoices;
    }

    addMonthField(invoices) {
        if (!invoices || invoices.length === 0) {
            return invoices;
        }
        invoices.map((invoice) => {
            const monthVal = moment(invoice.premiumDueDate).format("MMM YYYY");
            invoice.month = monthVal;
            return invoice;
        });
        return invoices;
    }

    setStatus(invoices) {
        if (!invoices || invoices.length === 0) {
            return invoices;
        }
        invoices.map((invoice) => {
            invoice.status = invoice.status === "Viewed" ? "Viewed" : "Unread";
            invoice.statusClass = invoice.status === "Viewed" ? "" : "invoice-status-unread";
            return invoice;
        });
        return invoices;
    }

    getInvoices() {
        let from, to;
        from = moment(this.state.dateRange.from).format("MM/DD/YYYY");
        to = moment(this.state.dateRange.to).format("MM/DD/YYYY");
        this.setState({ showLoader: true }, () => this.props.getInvoicesList(from, to));
    }

    goToInvoicesDetails(param) {
        this.props.history.push("/invoiceDetails", { invoiceId: param.invoiceNumber });
    }

    goToInvoicesDetailsForLatestInvoice(invoiceNumber) {
        this.props.history.push("/invoiceDetails", { invoiceId: invoiceNumber });
    }

    goToPaymentOptionsPage() {
        this.props.history.replace('/paymentOptions');
    }

    queueInvoiceDownload(data) {
        if (this.props.hpIdentity) {
            let memHccId = this.props.hpIdentity.memberUserClaims.memberHccId;
            this.props.getInvoicesPDF(memHccId, data.invoiceNumber);
        }
        else if (this.props.swhp) {
            let fromDate = new Date(data.fromDate);
            let dateObj = new Date("10/01/2019");
            if (fromDate > dateObj) {
                this.props.getInvoicesPDF(this.props.swhp, data.invoiceNumber);
            }
            else {
                alert("Invoices prior to October 1, 2019 may not be viewed on this portal.\n Please click the “Member Support” link in the left navigation to request more information..");
            }
        }
        else {
            console.log('no user identity present to access the invoice document.');
        }
    }

    handleInvoiceDownload() {
        if (this.props.error || !this.props.invoicePDF || this.props.invoicePDF === undefined || this.props.invoicePDF.status === 204) {
            //TODO - revisit this... 
            if (this.props.error) {
                switch (this.props.error.status) {
                    case 404:
                        alert("This particular invoice is not available at this time. Please check back later.");
                        return;
                    default:
                        alert("Unable to download document at this time.");
                        return;
                }
            }
        }
        else {
            FileSaver.saveAs(this.props.invoicePDF, this.props.invoicePDFName);
        }
    }


    dateChanged(filterType, data) {
        if (filterType === "date") {
            console.log("setting invoicesandpayments date range in localStorage");
            const fromDate = moment(data.dateRange.from).format("MM/DD/YYYY");
            const toDate = moment(data.dateRange.to).format("MM/DD/YYYY");
            const dateRangeObj = {
                from: fromDate,
                to: toDate,
                expire: "ONLOGOUT"
            }
            localStorage.setItem("invoicesAndPaymentsDateRange", JSON.stringify(dateRangeObj));
            this.setState({ dateRange: data.dateRange }, () => this.getInvoices());
        }
    }

    render() {
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        var columnMetadata = [
            {
                type: "string",
                title: "Month",
                value: "month",
                allowSorting: true
            },
            {
                type: "string",
                title: "Member",
                value: "memberName",
                allowSorting: true,
                subtextValue: "relation",
                subtextType: "string"
            },
            {
                type: "string",
                title: "Acct Name",
                value: "accountName",
                allowSorting: true
            },
            {
                type: "string",
                title: "Number",
                value: "invoiceNumber",
                allowSorting: true,
                clickCallback: this.queueInvoiceDownload,
            },
            {
                type: "string",
                title: "Bill To",
                value: "billTo",
                allowSorting: true
            },
            {
                type: "string",
                title: "Account ID",
                value: "accountId",
                allowSorting: true
            },
            {
                type: "date",
                title: "Premium Due",
                value: "premiumDueDate",
                allowSorting: true
            }
        ]

        var columnMetadataAmisys = [
            {
                type: "string",
                title: "Month",
                value: "month",
                allowSorting: true
            },
            {
                type: "string",
                title: "Member",
                value: "memberName",
                allowSorting: true,
                subtextValue: "relation",
                subtextType: "string"
            },
            {
                type: "string",
                title: "Acct Name",
                value: "accountName",
                allowSorting: true
            },
            {
                type: "string",
                title: "Number",
                value: "invoiceNumber",
                allowSorting: true,
                clickCallback: this.queueInvoiceDownload,
            },
            {
                type: "string",
                title: "Account ID",
                value: "accountId",
                allowSorting: true
            },
            {
                type: "date",
                title: "Premium Due",
                value: "premiumDueDate",
                allowSorting: true
            }
        ]

        var gridMetadata = {
            title: "",
            selectable: true,
            enableFilters: true,
            filters: [{ filterName: "Member", dataKeyToUse: "memberName" }, { filterName: "Account Name", dataKeyToUse: "accountName" }, { filterName: "Account ID", dataKeyToUse: "accountId" }],
            searchFields: ["invoiceNumber", "accountName", "accountId"],
            searchPlaceholder: "Search by Invoice number, account name or ID",
            dateField: "premiumDueDate",
            initialDate: this.state.dateRange,
            enableExport: true,
            enableSearch: true,
            enableDateRange: true,
            exportFormats: ["xls"],
            exportName: "Invoices and Payments",
            sortingEnabled: true,
            pagination: false, //not implemented
            rowsPerPage: 10, //not implemented
            rowClick: this.goToInvoicesDetails,
            stopDateFilterPropogation: true,
            filterCallback: this.dateChanged,
            columns: this.props.swhp ? columnMetadataAmisys : columnMetadata
        }

        return (
            <div className="container-fluid body-content hp">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="hp-title">
                            Invoices and Payments
                        </div>
                    </div>
                    <hr className="full-width"></hr>
                    <div className="col-12 maxWidth-content">
                        <div className="claim-wrapper">
                            {this.state.showLoader ?
                                <div id="claim-detail-spinner" className="spinner">
                                    <div className="bounce1" />
                                    <div className="bounce2" />
                                    <div className="bounce3" />
                                </div>
                                :
                                <div className="claim-container">
                                    {this.state.swhpShowLatestInvoiceSection &&
                                        <div id="latestInvoice" className="card">
                                            <div className="row">
                                                <div className="col-12 col-sm-12">
                                                    <span className="bold-text">Medical Premium</span>
                                                </div>
                                            </div>
                                            <hr></hr>
                                            <div className="row">
                                                <div className="col-12 col-sm-3">
                                                    <span className="bold-text">Due:</span> {moment(this.state.swhpLatestInvoice.premiumDueDate).format("MM/DD/YYYY")}
                                                </div>
                                                <div className="col-12 col-sm-3">
                                                    <span className="bold-text">Amount:</span> {this.state.swhpLatestInvoice.totalAmountDue !== null ? formatter.format(this.state.swhpLatestInvoice.totalAmountDue) : ""}
                                                </div>
                                                <div className="col-12 col-sm-6">
                                                    <span className="link-text cursor-pointer" onClick={() => this.goToInvoicesDetailsForLatestInvoice(this.state.swhpLatestInvoice.invoiceNumber)}>Invoice Details</span>
                                                    <span> / </span><span><span className="link-text cursor-pointer" onClick={() => this.goToPaymentOptionsPage()}>Payment Options</span></span>
                                                {
                                                    (this.state.isCobraMember || (this.props.hpIdentity && this.props.hpIdentity.roles.includes("InvoicePaymentSsoUsers"))) &&
                                                    <span><span> / </span> <span className="link-text cursor-pointer" onClick={() => this.props.ssoInvoicesandPayments()}>Pay Online</span></span>
                                                }
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    <DataGrid id="invoices-payments-data-grid" dataSource={this.state.invoicesList} gridOptions={gridMetadata} showLoader={this.state.showLoader} />
                                </div>
                            }

                        </div>
                    </div>
                </div>
            </div>
        );

    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        invoicesList: state.healthPlanServices.invoices,
        isFetching: state.healthPlanServices.isFetching,
        hpIdentity: state.session.healthPlanUserProfile,
        swhp: state.domain.hi,
        invoicePDF: state.healthPlanServices.invoicePDF,
        invoicePDFName: state.healthPlanServices.invoicePDFName,
        subscription: state.healthPlanServices.subscription,
        error: state.healthPlanServices.error,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getInvoicesList: (startDate, endDate) => dispatch({ type: types.HP_GET_INVOICES_LIST_START, startDate: startDate, endDate: endDate }),
        getInvoicesPDF: (MemberId, InvoiceNumber) => dispatch({ type: types.HP_GET_INVOICE_PDF_START, MemberId: MemberId, InvoiceNumber: InvoiceNumber }),
        getSubscriberInfo: () => dispatch({ type: types.HP_GET_SUBSCRIPTION_START }),
        ssoInvoicesandPayments: () => dispatch({ type: types.HP_SSO_INVOICESANDPAYMENTS_START }),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InvoicesAndPayments))